import * as React from 'react';
import { Modal, Button, Table } from 'react-bootstrap';
import { Bloodwork, BloodworkRange, BloodworkAnalysis, PanelField } from '../../models';
import Moment from 'react-moment';
import { MathUtils } from '../../utils/MathUtils';

type Props = {
  bloodwork: Bloodwork;
  bloodworkRanges: BloodworkRange[];
  show: boolean;
  onHide: () => void;
};

type State = {
  show: boolean;
};

export class BloodworkDetailsModal extends React.Component<Props, {}> {
  state: State  = {
    show: this.props.show
  };

  componentWillReceiveProps(nextProps: Props) {
    this.setState({
      show: nextProps.show
    });
  }

  handleClose = () => {
    this.props.onHide();
  }

  bloodworkDisplayValue(field: PanelField) {
    const { bloodwork } = this.props;
    if (field.id === 'clientId') {
      return bloodwork.client.name + ' - ' + bloodwork.client.displayGender;
    }
    if (field.id === 'collectionDate') {
      return <Moment format="MM/DD/YYYY">{bloodwork.collectionDate}</Moment>;
    }
    if (field.id === 'menstrualPhase') {
      return bloodwork.menstrualPhase;
    }

    let value = bloodwork[field.id] != null ? bloodwork[field.id] : undefined;
    
    if (field.isWBCDifferential) {
      if (field.isAbsolute) {
        const fieldId = field.id.replace('Absolute', '');
        value = bloodwork[fieldId];
        if (value != null) {
          value = bloodwork.percentageToAbsolute(value, field.precision);
        }
      } else if (value != null) {
        value = MathUtils.round(value * 100, field.precision);
      }
    }
    
    return value != null ? MathUtils.round(value, field.precision) : '';
  }

  createBloodworkDisplay() {
    const { bloodwork, bloodworkRanges } = this.props;
    // This is a hack to get the anionGap values in the display modal
    const bloodworkAnalysis = new BloodworkAnalysis({
      bloodwork,
      bloodworkRanges,
      bloodworkFields: PanelField.ALL_FIELDS
    });
    bloodworkAnalysis.init();

    bloodwork.anionGap = bloodworkAnalysis.anionGap.value;
    bloodwork.anionGapWithoutK = bloodworkAnalysis.anionGapWithoutK.value;
    bloodwork.nlr = bloodworkAnalysis.nlr.value;
    bloodwork.sodiumPotassiumRatio = bloodworkAnalysis.sodiumPotassiumRatio.value;

    return (
      <div>
        <div>
          <span className="labsmartz-label">Client:</span>
          {
            bloodwork.client && bloodwork.client.gender ? 
              <span>
                {bloodwork.client.name} - {bloodwork.client.displayGender}
              </span> 
            : ''
          }
        </div>
        <div>
          <span className="labsmartz-label">Collection Date:</span>
          <span>
            {bloodwork.collectionDate ? <Moment format="MM/DD/YYYY">{bloodwork.collectionDate}</Moment> : ''}
          </span>
        </div>
        <div>
          <span className="labsmartz-label">Create Date:</span>
          <span>
            {bloodwork.createDate ? <Moment format="MM/DD/YYYY">{bloodwork.createDate}</Moment> : ''}
          </span>
        </div>        
        <br />
        <Table striped bordered className="labsmartz-table bloodwork-table">
          <thead>
            <tr>
              <th>Marker</th>
              <th>Value</th>
              <th>Units</th>                         
            </tr>
          </thead>
          <tbody>
            { 
                PanelField.PANEL_MARKER_FIELDS.map((field: PanelField, index: number) => {
                  if (field.isHiddenForDisplay) {
                    return null;
                  }
                  return (
                    <tr key={index}>
                      <td>{field.label}</td>
                      <td>{this.bloodworkDisplayValue(field)}</td>
                      <td>{field.units}</td>
                    </tr>
                  );
                })
            }
          </tbody>
        </Table>
      </div>
    ); 
  }

  render() {
    console.log('BloodworkDetailsModal is rendering....');

    if (!this.state.show) {
      return '';
    }
    
    return (
      <Modal show={this.state.show} onHide={this.handleClose}>
        <Modal.Header closeButton style={{ backgroundColor: '#337ab7', color: '#fff' }}>
          <Modal.Title>Test Results</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {this.createBloodworkDisplay()}
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={this.handleClose}>Close</Button>
        </Modal.Footer>
      </Modal>
    );
  }
}
